import { Routes, Route, Navigate } from 'react-router-dom'
import { LangProvider } from './i18n'
import { AuthProvider, useAuth } from './auth'
import { PrefsProvider } from './prefs'
import { NavBar } from './components/NavBar'
import { ProtectedRoute } from './components/ProtectedRoute'
import { LoginPage } from './pages/LoginPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { ActivatePage } from './pages/ActivatePage'
import { ProfilePage } from './pages/ProfilePage'
import { PersonalTasksPage } from './pages/PersonalTasksPage'
import { AssignmentsPage } from './pages/AssignmentsPage'
import { DutySchedulePage } from './pages/DutySchedulePage'
import { GlobalSearchPage } from './pages/GlobalSearchPage'
import { PersonnelPage } from './pages/PersonnelPage'
import { TaskDictPage } from './pages/TaskDictPage'
import { AdminConsolePage } from './pages/AdminConsolePage'
import { AuditLogPage } from './pages/AuditLogPage'
import { StatsHubPage } from './pages/StatsHubPage'
import { DataReportsHubPage } from './pages/DataReportsHubPage'
import { MyPerformancePage } from './pages/MyPerformancePage'

function DefaultRedirect() {
  const { user } = useAuth()
  if (user?.role === 'admin') return <Navigate to="/admin" replace />
  return <Navigate to="/personal-tasks" replace />
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <PrefsProvider>
        <div style={{ fontFamily: 'system-ui, sans-serif', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <NavBar />
          <main style={{ flex: 1, padding: '24px' }}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/activate" element={<ActivatePage />} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/personal-tasks" element={<ProtectedRoute><PersonalTasksPage /></ProtectedRoute>} />
              <Route path="/my-performance" element={<ProtectedRoute roles={['member']}><MyPerformancePage /></ProtectedRoute>} />
              <Route path="/stats" element={<ProtectedRoute roles={['manager', 'admin']}><StatsHubPage /></ProtectedRoute>} />
              <Route path="/data-reports" element={<ProtectedRoute roles={['manager', 'admin']}><DataReportsHubPage /></ProtectedRoute>} />
              {/* Legacy routes redirected to hub containers */}
              <Route path="/overview" element={<Navigate to="/stats" replace />} />
              <Route path="/regional" element={<Navigate to="/stats" replace />} />
              <Route path="/leaderboard" element={<Navigate to="/stats" replace />} />
              <Route path="/data" element={<Navigate to="/data-reports" replace />} />
              <Route path="/noncompliant" element={<Navigate to="/task-dict#noncompliant-section" replace />} />
              <Route path="/assignments" element={<ProtectedRoute><AssignmentsPage /></ProtectedRoute>} />
              <Route path="/duty-schedule" element={<ProtectedRoute><DutySchedulePage /></ProtectedRoute>} />
              <Route path="/quarterly-report" element={<Navigate to="/data-reports" replace />} />
              <Route path="/global-search" element={<ProtectedRoute><GlobalSearchPage /></ProtectedRoute>} />
              <Route path="/personnel" element={<ProtectedRoute roles={['manager']}><PersonnelPage /></ProtectedRoute>} />
              <Route path="/members" element={<Navigate to="/personnel" replace />} />
              <Route path="/task-dict" element={<ProtectedRoute><TaskDictPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={['admin']}><AdminConsolePage /></ProtectedRoute>} />
              <Route path="/audit-log" element={<ProtectedRoute roles={['manager', 'admin']}><AuditLogPage /></ProtectedRoute>} />
              <Route path="/" element={<ProtectedRoute><DefaultRedirect /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
        </PrefsProvider>
      </AuthProvider>
    </LangProvider>
  )
}

export default App
